module.exports = __webpack_public_path__ + "static/media/favicon-32x32.2288a6a3.svg";